<template>
  <main>
    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
           <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                 <h4 class="mb-0 font-size-18">Backups</h4>
                 <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                       <li class="breadcrumb-item"><a href="javascript: void(0);">Your Servers</a></li>
                       <li class="breadcrumb-item active">Backups</li>
                    </ol>
                 </div>
              </div>
           </div>
        </div>
        <!-- end page title -->
        <center>
           <div class="col-lg-6">
              <div class="card card-body text-center">
                 <h4 class="card-title mt-0">Link your Google Drive!</h4>
                 <p class="card-text">Backup your server files to ensure that you will always have a copy in the event that an irreversible action occurs!</p>
                 <a href="#" class="btn btn-primary waves-effect waves-light">SIGN INTO GOOGLE DRIVE</a>
              </div>
           </div>
        </center>
      </div>
    </div>
  </main>
</template>

<script>
export default
{
  name: 'Backups',
  data () {
    return {}
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/panel/Backups.vue